import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import * as Unicons from '@iconscout/react-unicons';
import * as menuActions from './../../actions/menu';
import DateAndTime from './DateAndTime';
import { withRouter } from 'react-router-dom'
import {connect} from "react-redux";

class HeaderSection extends React.Component{
    openMenu = async () => {
        this.props.openMenu();
    }
    render = () => {
        return (
            <Grid container className="header-section">
                <Grid item xs={2}>
                <Typography variant="h2" align="center" color="textPrimary">
                <Unicons.UilBars className="cursor-pointer" size="25" color="#1a237e" onClick={this.openMenu} />

                </Typography>
                </Grid>
                <Grid item xs={8} className="date-time-section">
                    <DateAndTime />
                </Grid>
                <Grid item xs={2}>
                    <Typography variant="h2" align="center" color="textPrimary">
                    <Unicons.UilSync className="cursor-pointer" size="25" color="#1a237e" onClick={this.props.refreshButton} />

                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <span variant="h6" align="center" className="mt-2 d-block text-center text-primary" >
                        {this.props.registerAttendace.isUserInWorkPlace ? `${this.props.registerAttendace.userWorkplace.Name}` : "شما در محل کار حضور ندارید"}
                    </span>
                </Grid>
                
            </Grid>
        );
        
    } 
}
const mapToStateProps = (state) => {
    return state
};
export default withRouter(connect(mapToStateProps , menuActions)(HeaderSection))